import {
    Component, HostBinding, ChangeDetectionStrategy, ViewEncapsulation,
    ElementRef, AfterViewInit, Input, Output, EventEmitter,
} from '@angular/core';
import { UxAppShellService } from '@eui/core';
import { BaseDirective } from '../../../base.directive';

@Component({
    selector: 'eui-app-top-message',
    templateUrl: './top-message.component.html',
    changeDetection: ChangeDetectionStrategy.Default,
    styleUrls: ['./_styles/_index.scss'],
    encapsulation: ViewEncapsulation.None,
})
export class EuiAppTopMessageComponent extends BaseDirective implements AfterViewInit {
    @HostBinding('class')
    get cssClasses() {
        return [
            !this.isVisible ? `eui-app-top-message--hidden` : ``,
            super.getCssClasses('eui-app-top-message'),
        ].join(' ').trim();
    }
    @HostBinding('attr.role') role = 'banner';

    @Input() isCloseable = false;

    _isVisible = true;
    get isVisible(): boolean {
        return this._isVisible;
    }
    @Input() set isVisible(value: boolean) {
        this._isVisible = value;
        this._calculateHeight();
    }

    @Output() close = new EventEmitter<null>();

    constructor(
        public asService: UxAppShellService,
        private elRef: ElementRef,
    ) {
        super();
    }

    ngAfterViewInit() {
        this._calculateHeight();
    }

    onCloseClick(event: any) {
        this.isVisible = false;
        this.asService.activateTopMessageCssVars(0);
        this.close.emit();
    }

    private _calculateHeight() {
        setTimeout(() => {
            const height = this.elRef.nativeElement.offsetHeight;
            this.asService.activateTopMessage(height);
        });
    }
}
